<template>
  <div class="container" v-if="parceiro">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Ofertas do parceiro {{parceiro.nome}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
              <b-button :to="{name: 'OfertaForm', query: {parceiro: parceiro._id}}">Novo</b-button>
            </div>
          </div>
        </div>

        <div>
          <div class="row">
            <div class="col mb-2"></div>
          </div>

          <div class="row">
            <div class="col">
              <div class="element-box">
                <div class="mb-4">
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="totalCount"
                      :per-page="perPage"
                      :current-page="currentPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                  ></b-pagination>
                </div>

                <b-table
                    id="listOferta"
                    name="listOferta"
                    ref="listOferta"
                    striped
                    hover
                    bordered
                    show-empty
                    :empty-text="`Não há ofertas registradas para o parceiro ${parceiro.nome}`"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :items="getOfertas"
                    :fields="fieldList"
                >
                  <template slot="[desconto]" slot-scope="row">
                    {{row.item.symbol.name}} {{row.item.value}}
                  </template>
                  <template slot="[start_date]" slot-scope="row">
                    {{row.item.start_date | formatDate}}
                  </template>
                  <template slot="[end_date]" slot-scope="row">
                    {{row.item.end_date | formatDate}}
                  </template>
                  <template slot="[acoes]" slot-scope="row">
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        title="Excluir"
                        @click="excluir(row.item)"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        title="Editar"
                        @click="editar(row.item)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-button>

                    <b-button v-if="!row.item.status || row.item.status === '0'"
                              variant="outline-success" size="sm" title="Ativar"
                              @click="ativar(row.item)">
                      <i class="fa fa-check"></i>
                    </b-button>
                    <b-button v-else
                              variant="outline-danger" size="sm" title="Inativar"
                              @click="inativar(row.item)">
                      <i class="fa fa-times"></i>
                    </b-button>
                  </template>
                </b-table>


              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "OfertaList",
  data: () => ({
    currentPage: 1,
    perPage: 10,
    totalCount: 0,
    fieldList: [
      {
        key: 'event',
        label: 'Tipo'
      },
      {
        key: 'nome',
        label: 'Nome'
      },
      {
        key: 'desconto',
        label: 'Desconto'
      },
      {
        key: 'start_date',
        label: 'Data Inicio'
      },
      {
        key: 'end_date',
        label: 'Data Fim'
      },
      {
        key: 'acoes'
      }
    ],
    parceiro: null
  }),
  async created() {
    const {parceiro} = this.$route.query;
    this.parceiro = await axios.get(`/api/parceiro/${parceiro}`).then(response => response.data);
  },
  methods: {
    getOfertas(ctx) {
      this.currentPage = ctx.currentPage;
      let promise = axios.get(`/api/parceiro/${this.parceiro._id}/ofertas`, {
        params: {
          limit: this.perPage,
          page: ctx.currentPage
        }
      });
      return promise.then(response => {
        this.totalCount = response.data.totalCount;
        return response.data.data || [];
      });
    },
    voltar() {
      window.history.back();
    },
    editar(oferta) {
      this.$router.push({name: 'OfertaForm', query: {parceiro: this.parceiro._id, id: oferta._id}});
    },
    async excluir(oferta) {
      const value = await this.$bvModal.msgBoxConfirm('Deseja realmente remover a oferta?', {
        title: 'Excluir Oferta',
        centered: true,
        okTitle: 'Sim',
        cancelTitle: 'Não',
      });

      if (value) {
        try {
          this.$store.dispatch('setLoading', true);

          await axios.delete(`/api/oferta/${oferta._id}`);

          this.$root.$emit('bv::refresh::table', 'listOferta');
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('error', e);
        } finally {
          this.$store.dispatch('setLoading', false);
        }
      }
    },
    async ativar(oferta) {
      try {
        this.$store.dispatch('setLoading', true);

        const ofertaFind = await axios.get(`/api/oferta/${oferta._id}`).then(response => response.data);
        ofertaFind.status = 1;

        await axios.post(`/api/parceiro/${this.parceiro._id}/ofertas`, ofertaFind);

        this.$root.$emit('bv::refresh::table', 'listOferta');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error', e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    async inativar(oferta) {
      try {
        this.$store.dispatch('setLoading', true);

        const ofertaFind = await axios.get(`/api/oferta/${oferta._id}`).then(response => response.data);
        ofertaFind.status = 0;

        await axios.post(`/api/parceiro/${this.parceiro._id}/ofertas`, ofertaFind);

        this.$root.$emit('bv::refresh::table', 'listOferta');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error', e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    }
  }
}
</script>

<style scoped>

</style>
